import { Dictionary } from "../../../../react-core/Helpers/CommonHelper";
import { AssetClassType as Enum_AssetClassType } from "../../../../Wrap/Constants/Enums/Domain/Instrument/AssetClassType";
import { PerformanceMethod as Enum_PerformanceMethod } from "../../../../Wrap/Constants/Enums/Domain/PerformanceMethod";

export class Contents {
    public static Exit = "Exit";
    public static Pervious = "Previous";
    public static RequiredMsg = "Please answer the question.";
    public static RequiredSelection = "Please make a selection";
    public static CanNotBeEmpty = "Can not be empty";
    public static InvalidatePhone = "Only '+' and numbers allowed";
    public static DefaultLogoAdded = "No logo added";
    public static DefaultContactDetails = "No contact details added";
}

export class Landing {
    public static Welcome = "Welcome to your client portal";
    public static Configuration = "configuration";
    public static Subject = "This allows you to tailor the portal to your clients' needs.";
    public static Subject2 = "It's a simple 4 step process that should only take a few minutes.";
    public static BackToWrap = "Back to wrap";
    public static ConfigureNow = "Configure your Client Portal";
}

export class AddLogo {
    public static Title = "Adding a logo";
    public static Subject = "Would you like to add your firm logo to your client portal?";
    public static RadioTitle = "Do you want to add contact details?";
    public static Yes = "Yes";
    public static NotNow = "Not right now";
    public static NotNowMsg = "We will add the Standard Life logo, but don’t worry you can update this later.";
    public static GoToAdviserDetails = "Next > Contact details";
    public static LogRecommendations = "Logo recommendations";
    public static Rules = "We recommend the logo is within the following:";
    public static Li1 = "95px height by 250px width";
    public static Li2 = "Transparent background";
    public static Li3 = "In .png  .jpg  or .svg  formats";
    public static Li4 = "72 dpi density to look sharp on mobile";
    public static DoNotWorryMsg =
        "Don't worry if you're not sure of the dimensions as we'll show you what it looks like before you finish.";
    public static RequiredImg = "Please upload image";
}

export class ContactDetails {
    public static Title = "Adding adviser contact details";
    public static Subject = "You can provide your preferred firm contact details.";
    public static RadioTitle = "Do you want to add contact details?";
    public static FirmName = "Firm name";
    public static FirmAddressLine1 = "Firm address line 1";
    public static FirmAddressLine2 = "Firm address line 2";
    public static FirmAddressLine3 = "Firm address line 3";
    public static FirmAddressLine4 = "Firm address line 4";
    public static FrimPostCode = "Firm postcode";
    public static Phone = "Phone";
    public static EmaillAddress = "Email address";
    public static Website = "Website";
    public static RightMsg =
        "This will be at firm level so you might want to put in a general support desk number and your website details.";

    public static Key_FirmName = "firmName";
    public static Key_FirmAddressLine1 = "firmAddressLine1";
    public static Key_FirmAddressLine2 = "firmAddressLine2";
    public static Key_FirmAddressLine3 = "firmAddressLine3";
    public static Key_FirmAddressLine4 = "firmAddressLine4";
    public static Key_FirmPostCode = "firmPostcode";
    public static Key_Phone = "phone";
    public static Key_Email = "email";
    public static Key_Website = "website";

    public static GoToInvestments = "Next > Investments";

    public static ExampleMsg = "This is an example of how your details will look.";
}
export class Investments {
    public static Title = "Investments";
    public static Subject =
        "On the investments page (if switched on for the client), what level of investments detail would you like to show?";

    public static radioDics: Dictionary[] = [
        { key: Enum_AssetClassType.Tier1 + "", value: "Tier 1 (Cash, Bonds, Equities)" },
        {
            key: Enum_AssetClassType.Tier2 + "",
            value: "Tier 2 (an extra level of detail e.g. UK Bonds, Offshore Bonds)",
        },
        { key: Enum_AssetClassType.NoAssetClass + "", value: "No Tier (only shows the underlying investments listed)" },
    ];

    public static GoToPerformance = "Next > Performance";
    public static Line1 =
        "If you provide Standard or Advanced access levels to your clients, they can access the Investment page data. This page lists their investments, allocation, units, price and value.";
    public static Line2 =
        "In addition, you can choose how clients will view the asset classification of their investments – either with no Asset Class data (they will just see the list of investments held) or a Tier 1 (high level Asset Classes) or Tier 2 (more detailed Asset Classes).";
}

export class Performance {
    public static Title = "Performance";
    public static Subject = "Which performance methodology do you want to set?";
    public static radioDics: Dictionary[] = [
        { key: Enum_PerformanceMethod.Simple + "", value: "Simple" },
        { key: Enum_PerformanceMethod.IRR + "", value: "IRR" },
    ];

    public static NextReview = "Next > Review";
    public static Line1 = "Simple return calculation";
    public static Line2 =
        "This is the percentage (%) measure to show how your investments have performed over the selected time period, without any adjustment for the date that each transaction occurred.  It's calculated by dividing the change in value by the total amount invested over the time period.";
    public static Line3 = "Internal rate of return (IRR) calculation";
    public static Line4 =
        "This is the percentage (%) time-weighted measure to show how your investments have performed over the selected time period.  It's calculated by dividing the change in value by the time and the value of the transactions that took place over the time period.";
}

export class Review {
    public static Title = "Review your chosen settings";
    public static HeadSettings = "Setting";
    public static HeadDetails = "Details";
    public static HeadEdit = "Would you like to edit?";
    public static HeadImage = "Image";

    public static Row1Td1 = "1. Logo";
    public static Row2Td1 = "2. Contact details";
    public static Row3Td1 = "3. Investments";
    public static Row4Td1 = "4. Performance";
    public static Edit = "Edit";
    public static Submit = "Submit >";

    public static Key_Logo = "Logo";
    public static Key_ContactDetails = "ContactDetails";
    public static Key_Investments = "Investments";
    public static Key_Performance = "Performance";
    public static LoadingMsg = "We're saving your settings now.";
    public static LogoAdded = "Logo added";
}

export const assetClassType = {
    0: "NotSet",
    1: "NoAssetClass",
    2: "Tier1",
    3: "Tier2",
};

export const performanceMethod = {
    0: "NotSet",
    1: "Simple",
    2: "IRR",
};

export class Submit {
    public static Title = "Thank you.";
    public static Subject = "Your client portal has been set up successfully.";

    public static ColumnActivityDate = "Activity date";
    public static ColumnReferenceNumber = "Reference number";
    public static ColumnCreateBy = "Created by";
    public static ColumnSubmittedBy = "Submitted by";
    public static ColumnAction = "Action";

    public static BackToWrap = "Back to Wrap >";
}

export class ConfigurationDetail {
    public static title = "Your client portal configuration details";
    public static Edit = "Edit configuration";
    public static BackToWrap = "Back to wrap";

    public static ColumnDate = "Date";
    public static ColumnSubmittedBy = "Submitted by";
    public static ColumnAction = "Action";

    public static View = "View";
    public static Logo = "Logo:";
    public static ContactDetails = "Contact details:";
    public static Investments = "Investments:";
    public static Performance = "Performance:";

    public static LogoAdded = "Logo added";
}

export enum ImageStatus {
    None,
    IsNotAnImage,
    ImageChosen,
    ImageSizeNotMatch,
}
